import { PageNav, NavTab } from "@ugg/shared/components/common/PageNav";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { useActiveSpecialModes, SPECIAL_GAME_MODES } from "@ugg/shared/utils/special-game-modes";
import { tierListPageUrls } from "@ugg/shared/pages/tier-list-pages";
import { QueueTypeS } from "@ugg/shared/utils/queue-type-helpers";

export function TierListPageNav({ className }: { className?: string }) {
  const activeModes = useActiveSpecialModes({ ssr: true });

  const isAramMayehmActive = activeModes.findIndex((mode) => mode === QueueTypeS.ARAM_MAYHEM);

  const specialModeTabs: NavTab[] = activeModes.map((mode) => {
    const { tierListPageName, tierListSettings, newTag } = SPECIAL_GAME_MODES[mode];
    return {
      to: tierListPageUrls[tierListPageName],
      label: tierListSettings.title.main,
      reset: true,
      new: newTag,
    };
  });

  const tabs: NavTab[] = [
    {
      to: AppRoutes.DEFAULT_TIER_LIST,
      label: "Tier List",
      activePaths: [
        AppRoutes.TOP_TIER_LIST,
        AppRoutes.JUNGLE_TIER_LIST,
        AppRoutes.MID_TIER_LIST,
        AppRoutes.ADC_TIER_LIST,
        AppRoutes.SUPPORT_TIER_LIST,
      ],
    },
    ...specialModeTabs,

    // Drew: We will show the augment tier list for the site, but not the app
    ...(process.env.UGG_PUBLIC_PLATFORM !== "app" && isAramMayehmActive
      ? [{ to: AppRoutes.ARAM_MAYHEM_AUGMENT_TIER_LIST, label: "ARAM Mayhem Augment Tier List", new: true }]
      : []),

    { to: AppRoutes.DUO_TIER_LIST, label: "Duo Tier List" },

    // Drew: We will hide Combat/Objectives for the site and keep it on the app
    ...(process.env.UGG_PUBLIC_PLATFORM !== "app"
      ? []
      : [
          { to: AppRoutes.COMBAT_TIER_LIST, label: "Combat" },
          { to: AppRoutes.OBJECTIVES_TIER_LIST, label: "Objectives" },
        ]),
  ];

  return <PageNav className={className} tabs={tabs} />;
}
